export default {
  INVISIBLE: 0,
  VISIBLE: 1,
  DISABLED: 2
}
